export enum CarekartePassRole {
  DAI = 1,
  STAFF = 2,
  RELATIVE = 3,
  PARTICIPANT = 4,
  STAFF_OF_DAI = 98,
}
